<script>
  import Picture from './picture.svelte'

  export let image
</script>

<div class="header-image">
  <Picture mediaInfo={image.mediaInfo} loadingTechnique="eager" fitImageAsCover={true} />
</div>

<style>
  .header-image {
    position: absolute;
    z-index: -1;
    top: 0;
    width: 100vw;
    max-width: 1280px;
    aspect-ratio: 16/9;
    overflow: hidden;
  }
  .header-image::after {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(transparent, #0a2343);
    content: '';
  }
</style>
